import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839854093_caja-86b7d38f.png';
export const heroGuarantees = ['Descărcare digitală imediată', 'Plată unică', 'Fără abonament', 'Garanție de satisfacție 7 zile'];
export const stats = [{
  value: '240',
  label: 'Pagini în volumele principale'
}, {
  value: '6',
  label: 'Volume digitale de religie'
}, {
  value: '9',
  label: 'Clase – de la pregătitoare la a VIII-a'
}, {
  value: '5',
  label: 'Bonusuri incluse'
}, {
  value: '1',
  label: 'Sistem complet de predare'
}];
export const differenceStats = [{
  value: 'Clasele 0–VIII',
  label: 'Material organizat pentru primar și gimnaziu'
}, {
  value: '6 volume digitale',
  label: 'De la creație și Biblie la sărbători, Biserică și evaluare'
}, {
  value: 'PDF-uri printabile',
  label: 'Le folosești digital sau le printezi pentru clasă'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Duminicile dispar',
  text: 'Ore întregi în fața calculatorului ca să pregătești orele de religie ale săptămânii viitoare – și tot nu ai terminat.'
}, {
  title: 'Ore de căutat pe internet',
  text: 'Fișele găsite pe diverse site-uri sunt prea simple, prea încărcate sau trebuie verificate și adaptate înainte să le poți folosi.'
}, {
  title: 'Fișele se fac de la zero',
  text: 'Întrebări, imagini, așezare în pagină și răspunsuri – ce ar trebui să dureze minute devine o muncă lungă.'
}, {
  title: 'Greu de făcut religia vizuală',
  text: 'Povestirile biblice, părțile bisericii sau sărbătorile cer imagini clare pentru fiecare temă nouă.'
}, {
  title: 'Evaluarea durează',
  text: 'Teste, bareme, calificative și urmărirea progresului elevilor înseamnă și mai multă muncă după ore.'
}, {
  title: 'Stres înainte de fiecare oră',
  text: 'Când timpul nu ajunge, improvizezi și aduni materiale în ultimul minut.'
}];
export const afterItems = ['Un pachet organizat de religie pentru clasele pregătitoare – a VIII-a', 'Lecții gata de predat, minut cu minut', 'Povestiri biblice spuse simplu și fidel', 'Fișe de lucru care se printează direct', 'Sărbătorile anului bisericesc explicate vizual', 'Jocuri și activități pentru începutul orei', 'Planificare anuală pe clase', 'Teste, bareme și răspunsuri', 'Calificative la primar și note la gimnaziu'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Duminica se duce pe planificare',
  text: 'Îți petreci o parte din weekend pregătind orele de religie pentru săptămâna viitoare?'
}, {
  icon: FolderSearchIcon,
  title: 'Nu știi ce activitate să alegi',
  text: 'Cauți mereu fișe și activități potrivite cu vârsta elevilor tăi?'
}, {
  icon: LightbulbIcon,
  title: 'Vrei explicații mai clare',
  text: 'Ai nevoie de material vizual ca să explici simplu povestirile biblice, sărbătorile sau rugăciunea?'
}, {
  icon: PencilRulerIcon,
  title: 'Vrei să nu mai faci totul de la zero',
  text: 'Ți-ai dori ca lecțiile, fișele și testele să fie deja pregătite?'
}, {
  icon: ShuffleIcon,
  title: 'Elevii au nevoie de mai multă implicare',
  text: 'Vrei mai multe jocuri, desene și activități care să-i țină atenți la oră?'
}, {
  icon: LayoutGridIcon,
  title: 'Ai nevoie de o structură clară',
  text: 'Vrei tot materialul adunat la un loc, ca să găsești repede ce-ți trebuie?'
}];

// Spine colours mirror the physical box (green, blue, orange, red, purple, teal).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Volumul 01',
  level: 'Cl. 0–VIII',
  title: 'Începutul anului: creația și rugăciunea',
  tagline: 'Tot anul școlar organizat dintr-o privire.',
  intro: 'Primul volum îți dă planificarea anuală pe clase, calendarul sărbătorilor și primele 12 lecții minut cu minut.',
  items: ['Planificare anuală pe clase', 'Calendarul sărbătorilor din anul școlar', 'Momentele unei ore de religie', '12 lecții minut cu minut', 'Facerea lumii, rugăciunea, Biserica', 'Fișe de lucru printabile', 'Jocuri pentru ora de religie', 'Test și descriptori de performanță', 'Răspunsuri și barem'],
  outro: 'Intri la oră cu planul gata făcut.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 02',
  level: 'Cl. 0–VIII',
  title: 'Vechiul Testament',
  tagline: 'Marile povestiri biblice, pe înțelesul fiecărei vârste.',
  intro: 'Al doilea volum aduce povestirile Vechiului Testament în lecții gata de predat, fidele Sfintei Scripturi.',
  items: ['Iosif și frații săi', 'Moise și ieșirea din Egipt', 'Cele Zece Porunci', 'David și Goliat', 'Profeții', 'Hărți și linii ale timpului', 'Fișe de lucru cu răspunsuri', 'Jocuri de recapitulare', 'Teste scurte'],
  outro: 'Elevii povestesc, înțeleg și își amintesc.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 03',
  level: 'Cl. 0–VIII',
  title: 'Noul Testament',
  tagline: 'Viața și învățătura Mântuitorului, explicate simplu.',
  intro: 'Al treilea volum urmează viața Mântuitorului: Botezul, pildele, minunile, Patimile și Învierea.',
  items: ['Botezul Domnului', 'Chemarea apostolilor', 'Pildele Mântuitorului', 'Minunile Mântuitorului', 'Predica de pe munte', 'Intrarea în Ierusalim', 'Patimile și Învierea', 'Fișe cu răspunsuri', 'Teste și bareme'],
  outro: 'Evanghelia, aproape de viața elevilor.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 04',
  level: 'Cl. 0–VIII',
  title: 'Sărbătorile anului bisericesc',
  tagline: 'De la Crăciun la Rusalii, cu tradițiile românești.',
  intro: 'Al patrulea volum îți dă câte o lecție pentru fiecare mare sărbătoare din anul școlar, cu obiceiurile românești.',
  items: ['Sfântul Andrei și Sfântul Nicolae', 'Nașterea Domnului și colindele', 'Botezul Domnului', 'Sfinții Trei Ierarhi', 'Buna Vestire și Floriile', 'Sfintele Paști', 'Înălțarea și Rusaliile', 'Fișe și activități de sezon', 'Teste scurte'],
  outro: 'Fiecare sărbătoare, pregătită din timp.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 05',
  level: 'Cl. 0–VIII',
  title: 'Biserica, Sfintele Taine și sfinții',
  tagline: 'Viața liturgică explicată copiilor cu respect.',
  intro: 'Al cincilea volum prezintă biserica, Sfânta Liturghie, Sfintele Taine, rugăciunea și sfinții români.',
  items: ['Părțile bisericii', 'Sfânta Liturghie pe înțelesul copiilor', 'Cele șapte Sfinte Taine', 'Rugăciunile de bază', 'Icoana și cinstirea ei', 'Sfinți români', 'Mănăstirile din România', 'Fișe cu răspunsuri', 'Teste și bareme'],
  outro: 'Elevii înțeleg ce văd și trăiesc în biserică.',
  spine: 'bg-purple-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 06',
  level: 'Cl. 0–VIII',
  title: 'Valori creștine și evaluare',
  tagline: 'Calificative și note, fără seri întregi la birou.',
  intro: 'Al șaselea volum leagă credința de viața de zi cu zi și conține evaluări, teste în două variante și bareme.',
  items: ['Iubirea, iertarea și recunoștința', 'Familia și prietenia', 'Ajutorul celor în nevoie', 'Calificative FB, B, S, I la primar', 'Note de la 1 la 10 la gimnaziu', 'Evaluări inițiale și finale', 'Teste în variantele A și B', 'Portofoliul elevului', 'Bareme și răspunsuri'],
  outro: 'Evaluarea devine simplă și corectă.',
  note: 'Materialul este creat independent, în acord cu învățătura Bisericii Ortodoxe, și nu este o publicație a Patriarhiei Române sau a Ministerului Educației.',
  spine: 'bg-teal-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 volume digitale pentru clasele pregătitoare – a VIII-a',
  text: 'Un pachet complet de religie care te ajută să planifici și să predai tot anul școlar. Fiecare volum are 40 de pagini cu lecții, fișe, jocuri și activități pentru clasă.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Lecții gata de predat',
  text: 'Nu mai pornești de la o pagină goală. Lecții clare, minut cu minut, de la rugăciunea de început la reflecția finală.'
}, {
  icon: FileTextIcon,
  title: 'Fișe de lucru printabile',
  text: 'Fișe pe care le printezi și le folosești imediat – adevărat sau fals, potriviri, ordonare, desen și careuri.'
}, {
  icon: ShapesIcon,
  title: 'Povestiri biblice vizuale',
  text: 'Ilustrații mari și clare pentru fiecare povestire, fără a reprezenta chipurile sfinte.'
}, {
  icon: DicesIcon,
  title: 'Jocuri și activități',
  text: 'Jocuri de 5–10 minute pentru începutul orei și pentru recapitulare, care îi țin pe elevi implicați.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Evaluări și răspunsuri',
  text: 'Teste, descriptori de performanță și bareme gata făcute pentru corectare și urmărirea progresului.'
}, {
  icon: CalendarCheckIcon,
  title: 'Planificare anuală',
  text: 'Sprijin pentru organizarea orelor de religie pe clase și pe anul bisericesc.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839860182_vol1-p10-05c1f3ca.webp",
    "label": "Lecția 1 · Pagina 10",
    "title": "Dumnezeu a creat lumea",
    "text": "Cele șase zile ale creației în imagini, cu ideile de reținut și momentele orei minut cu minut."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839866050_vol1-p16-4889ed8e.webp",
    "label": "Lecția 4 · Pagina 16",
    "title": "Biserica, casa lui Dumnezeu",
    "text": "Pronaosul, naosul și altarul explicate vizual, cu planul orei pentru clasele III–IV."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839872326_vol1-p13-9d954d9a.webp",
    "label": "Fișă de lucru · Pagina 13",
    "title": "Primii oameni",
    "text": "O fișă printabilă de adevărat sau fals, cu răspunsurile la final."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839878182_vol1-p28-a37cc20b.webp",
    "label": "Lecția 10 · Pagina 28",
    "title": "Nașterea Domnului",
    "text": "Povestea Nașterii și tradițiile românești de Crăciun: colindele și umblatul cu Steaua."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/fe5285f0-356c-4451-8987-b61e7f8993f6/1793839884606_vol1-p08-58927280.webp",
    "label": "Planificare · Pagina 8",
    "title": "Sărbătorile din anul școlar",
    "text": "Calendarul sărbătorilor de la Nașterea Maicii Domnului la Sfinții Constantin și Elena."
  }
];
export const pageTypes = ['Lecții gata de predat', 'Fișe printabile', 'Planificare și calendar', 'Evaluări și răspunsuri'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Rugăciune și start în 5 minute',
  text: '40 de cartonașe ca să începi ora de religie cu clasa liniștită și atentă.',
  items: ['Rugăciuni pentru începutul orei', 'Întrebări de start', 'Ghicitori biblice', 'Jocuri de liniștire'],
  benefit: 'Începutul orei, rezolvat în câteva secunde.'
}, {
  title: 'Dosarul pentru suplinitor',
  text: '12 ore de religie pe care orice suplinitor le poate preda fără pregătire.',
  items: ['Ore pentru toate clasele', 'Teme universale, potrivite oricând', 'Fișe pentru elevi cu răspunsuri', 'Fișă de predare'],
  benefit: 'Liniște când lipsești de la școală.'
}, {
  title: 'Comunicarea cu părinții',
  text: 'Mesaje gata scrise pentru tot anul: ora de religie, vizite la biserică, serbări și note.',
  items: ['30 de mesaje gata de trimis', 'Mesaje pentru sărbători', 'Acord pentru vizita la biserică', 'Plan pentru ședința cu părinții'],
  benefit: 'Comunicare clară, fără să scrii totul de la zero.'
}, {
  title: 'Serbări școlare gata',
  text: '5 scenarii complete pentru Crăciun, Paști, Sfântul Nicolae, Trei Ierarhi și sfârșitul anului.',
  items: ['Texte complete pentru roluri', 'Colinde tradiționale în ordine', 'Calendar de repetiții', 'Invitații pentru părinți'],
  benefit: 'O serbare frumoasă, fără nopți nedormite.'
}, {
  title: 'Vizita la biserică și la mănăstire',
  text: '6 vizite gata pregătite, cu traseu, reguli și fișe de observație.',
  items: ['Părțile bisericii', 'Sfânta Liturghie pentru copii', 'Fișe de observație cu răspunsuri', 'Listă de verificare'],
  benefit: 'O ieșire cu clasa, organizată de la A la Z.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Deschizi RELIGIE GATA DE PREDAT™',
  text: 'Descarci pachetul și deschizi volumul potrivit pentru tema ta.'
}, {
  title: 'Alegi lecția și fișa',
  text: 'Găsești tema și alegi lecția, fișa sau jocul potrivit pentru clasa ta.'
}, {
  title: 'Te pregătești în 5 minute',
  text: 'Citești planul minut cu minut și printezi ce ai nevoie.'
}, {
  title: 'Printezi și predai',
  text: 'Printezi fișele sau folosești materialul digital – și intri la oră cu un plan clar.'
}];
export const audienceItems = ['Predai Religie la clasele pregătitoare – a IV-a', 'Predai Religie la gimnaziu, clasele V–VIII', 'Vrei tot materialul anului școlar organizat', 'Nu vrei să mai faci fiecare fișă de la zero', 'Ai nevoie de activități care îi țin pe copii atenți', 'Vrei povestiri biblice explicate vizual', 'Vrei teste, bareme și răspunsuri gata făcute', 'Vrei să câștigi timp la planificarea săptămânală'];
export const timeValueTasks = ['Cauți fișe și imagini', 'Scrii întrebări și exerciții', 'Pregătești povestirea biblică', 'Organizezi serbările', 'Corectezi și urmărești progresul elevilor'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 volume digitale – 240 de pagini',
  detail: 'Creația, Vechiul și Noul Testament, sărbători, Biserica, valori și evaluare'
}, {
  label: '5 bonusuri fără cost suplimentar',
  detail: 'Start în 5 minute, dosar pentru suplinitor, părinți, serbări și vizita la biserică'
}, {
  label: 'Pentru clasele pregătitoare – a VIII-a',
  detail: 'Lecții gata de predat, fișe printabile și răspunsuri'
}];
export const offerIncludes = ['Descărcare digitală imediată', 'Fișiere PDF de păstrat', 'Fișe printabile', 'Nu se trimite produs fizic'];
export const PRICE = '99 lei';

// Only add authentic reviews. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Cum primesc materialul?',
  a: 'RELIGIE GATA DE PREDAT™ se livrează digital. După cumpărare primești acces la fișiere PDF pe care le poți descărca și păstra. Le poți folosi pe calculator, tabletă sau telefon și printezi fișele de care ai nevoie.'
}, {
  q: 'Este adaptat pentru școala din România?',
  a: 'Da. Materialul este creat pentru ora de Religie (cultul ortodox), clasele pregătitoare – a VIII-a, după structura programelor școlare. Este un material independent, în acord cu învățătura Bisericii Ortodoxe, și nu o publicație a Patriarhiei Române sau a Ministerului Educației.'
}, {
  q: 'Este potrivit pentru clasele pregătitoare – a VIII-a?',
  a: 'Da. Cele șase volume au materiale pentru primar și pentru gimnaziu. Fiecare lecție este marcată pe clase, ca să alegi repede ce se potrivește.'
}, {
  q: 'Chiar pot pregăti o oră în 5 minute?',
  a: 'RELIGIE GATA DE PREDAT™ este gândit ca să-ți scurteze pregătirea. Deschizi un volum, alegi o lecție gata făcută și o parcurgi în aproximativ cinci minute. Timpul poate varia în funcție de lecție, de clasă și de adaptările de care ai nevoie.'
}, {
  q: 'Ajunge materialul pentru tot anul școlar?',
  a: 'Da. Pachetul conține lecții și activități pentru tot anul, organizate după anul școlar și anul bisericesc. Le alegi, le combini și le adaptezi după planificarea ta.'
}, {
  q: 'Cum sunt reprezentate persoanele sfinte?',
  a: 'Cu respect. Ilustrațiile arată povestirile, locurile și obiectele, iar chipurile Mântuitorului, Maicii Domnului și ale sfinților nu sunt desenate. Textele biblice sunt repovestite simplu și fidel Sfintei Scripturi.'
}, {
  q: 'Sunt incluse răspunsurile?',
  a: 'Da. Fiecare volum include răspunsurile la fișe și baremele testelor.'
}, {
  q: 'Pot folosi materialul cu elevi de vârste diferite?',
  a: 'Da. Lecțiile sunt marcate pe cicluri – pregătitoare–II, III–IV și V–VIII – iar multe activități se pot adapta ușor pentru alte clase.'
}, {
  q: 'Trebuie să printez tot?',
  a: 'Nu. Alegi singur ce pagini printezi și poți folosi o parte din material și digital.'
}, {
  q: 'Sunt incluse cele cinci bonusuri?',
  a: `Da. Toate cele cinci bonusuri sunt incluse în pachet fără cost suplimentar – totul pentru ${PRICE}.`
}, {
  q: 'Este un abonament?',
  a: 'Nu. Plătești o singură dată și primești acces la materialul digital. Fără plăți recurente.'
}, {
  q: 'Pot păstra fișierele?',
  a: 'Da. Poți descărca și păstra fișierele PDF pentru folosire ulterioară, conform condițiilor de utilizare ale produsului.'
}, {
  q: 'Pot folosi materialul pe telefon sau tabletă?',
  a: 'Da. Fișierele PDF se deschid pe calculator, tabletă și telefon. Pentru a verifica așezarea fișelor înainte de printare, îți recomandăm calculatorul sau tableta.'
}, {
  q: 'Există garanție?',
  a: 'Da. RELIGIE GATA DE PREDAT™ are garanție de satisfacție de 7 zile. Dacă materialul nu corespunde așteptărilor tale, ne poți contacta și cere rambursarea în perioada de garanție, conform condițiilor.'
}];
export const footerLinks = ['Termeni și condiții', 'Politica de confidențialitate', 'Politica de rambursare', 'Contact'];
